/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

// Display names for renamable entities. Change only the singular/plural/article
// values below to rename them across the UI. Backend, API paths, routes,
// permission keys and code identifiers keep using "account" / "sub-account" / "service-request".
const buildLabel = (singular, plural, article = 'a') => ({
  singular,                                            // "Property"
  plural,                                              // "Properties"
  singularLower: singular.toLowerCase(),               // "property"
  pluralLower: plural.toLowerCase(),                   // "properties"
  withArticle: `${article} ${singular.toLowerCase()}`, // "a property"
});

export const ACCOUNT_LABEL = buildLabel('Organization', 'Organizations', 'an');
export const SUB_ACCOUNT_LABEL = buildLabel('Property', 'Properties');
export const SERVICE_REQUEST_LABEL = buildLabel('Work Order', 'Work Orders');
